export enum InputType {
  Text = 'text',
  Tel = 'tel',
  Password = 'password',
}

export enum InputSize {
  S = 's',
  M = 'm',
  L = 'l',
  XL = 'xl',
}
